import { Stack, Box, CircularProgress } from "@mui/material";
import {
  ChoiceType,
  Message as MessageProps,
  MessageType,
} from "../../../apis/copilot/types.ts";
import Markdown from "markdown-to-jsx";
import { Select } from "./Select/Select";
import { Actions } from "./Actions";

const AI_MESSAGE_BG_COLOR = "#EDE7F6";
const HUMAN_MESSAGE_BG_COLOR = "#F5F5F5";

interface Props extends MessageProps {
  showRetry: boolean;
}

export const Message: React.FC<Props> = ({
  id,
  type,
  payload,
  rate,
  showRetry,
}) => {
  return (
    <Stack
      flexDirection="column"
      marginLeft={type === MessageType.HUMAN_MESSAGE ? "55px" : "0px"}
      marginRight={type === MessageType.HUMAN_MESSAGE ? "0px" : "20px"}
      bgcolor={
        type === MessageType.HUMAN_MESSAGE
          ? HUMAN_MESSAGE_BG_COLOR
          : AI_MESSAGE_BG_COLOR
      }
      px={2}
      py={2}
      paddingBottom={showRetry ? 0.5 : undefined}
      borderRadius="30px"
      gap="10px"
    >
      {type === MessageType.LOADING ? (
        <Stack
          id="copilot-thinking"
          direction="row"
          alignItems="center"
          spacing={2}
        >
          <CircularProgress size={28} thickness={4} sx={{ color: "#5F32C6" }} />
          <Box
            fontWeight={700}
            fontSize="14px"
            color="#5F32C6"
            fontFamily="Roboto, sans-serif"
          >
            Thinking ...
          </Box>
        </Stack>
      ) : (
        <Box
          fontFamily="Roboto, sans-serif"
          fontSize="14px"
          fontWeight={400}
          lineHeight={1.43}
          letterSpacing="0.15px"
          sx={{
            "& > *": {
              margin: 0,
            },
            "& pre": {
              backgroundColor: "#f5f5f5",
              padding: "8px",
              borderRadius: "4px",
            },
            "& code": {
              backgroundColor: "#f5f5f5",
              padding: "2px 4px",
              borderRadius: "4px",
            },
            "& blockquote": {
              borderLeft: "4px solid #ccc",
              paddingLeft: "16px",
              fontStyle: "italic",
            },
            "& a": {
              color: "#1976d2",
              textDecoration: "none",
            },
            "& ul, & ol": {
              paddingLeft: "20px",
            },
          }}
        >
          <Markdown>{payload.content}</Markdown>

          {payload.react_content && payload.react_content}
        </Box>
      )}

      {type === MessageType.AI_SELECT_MESSAGE && (
        <Select
          messageId={id}
          choiceType={payload.choice_type as ChoiceType}
          choices={payload.choices || []}
        />
      )}

      {(type === MessageType.AI_MESSAGE ||
        type === MessageType.AI_SELECT_MESSAGE ||
        type === MessageType.AI_CHUNK) && (
        <Actions messageId={id} rate={rate} showRetry={showRetry} />
      )}
    </Stack>
  );
};
